import { connect } from 'react-redux';

import { getMetainf, getUsageChartOptions } from '../../reducers/analyticsApp';
import {
  changeUsageView,
  setUsageColumnChartSorting,
  toggleUsageAdaptive,
  toggleUsageAverageLine,
  toggleUsageCalcTotal,
  toggleUsageMedianLine,
  toggleUsageTrendLine,
} from '../../actions/usage';
import ExecutionOptionsBar from '../../components/common/ExecutionOptionsBar';
import {
  changeAdaptive,
  onChangeSorting,
  toggleAverage,
  toggleGrandTotal,
  toggleMedian,
  toggleTrend,
} from '../../actions/chart';

const mapStateToProps = (state) => ({
  metainf: getMetainf(state),
  selectStyle: { width: 165 },
  options: getUsageChartOptions(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChangeView: (view) => dispatch(changeUsageView(view)),

  onChangeSorting: (sorting) =>
    onChangeSorting(sorting, () => dispatch(setUsageColumnChartSorting(sorting))),
  toggleGrandTotal: (e, columnChartSorting) =>
    toggleGrandTotal(e, columnChartSorting, () => dispatch(toggleUsageCalcTotal())),
  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleUsageTrendLine())),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleUsageAverageLine())),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleUsageMedianLine())),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleUsageAdaptive())),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
